import React, { useContext } from 'react';

import RemoteAccessTotalsContext from '@totem/components/services/remoteAccess/totals/RemoteAccessTotalsContext';
import TotalsContainer from '@totem/components/services/remoteAccess/totals/TotalsContainer';
import RemoteAccessTotalsV2Container from '@totem/components/services/remoteAccess/v2/totals/RemoteAccessTotalsV2Container';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';

const RemoteAccessSection = () => {
  const { data } = useContext(RemoteAccessTotalsContext);
  const hasRemoteAccessTotals = typeof data !== 'undefined' && data !== null;
  const showSection = hasRemoteAccessTotals;

  return (
    <>
      {showSection && (
        <IBCard title={'Remote Access'} isCovered>
          <RemoteAccessTotalsV2Container>
            <TotalsContainer />
          </RemoteAccessTotalsV2Container>
        </IBCard>
      )}
    </>
  );
};

export default RemoteAccessSection;
